import { render, staticRenderFns } from "./NationalTrademarkSearchOwnerList.vue?vue&type=template&id=71fa7c56&"
import script from "./NationalTrademarkSearchOwnerList.vue?vue&type=script&lang=js&"
export * from "./NationalTrademarkSearchOwnerList.vue?vue&type=script&lang=js&"
import style0 from "./NationalTrademarkSearchOwnerList.vue?vue&type=style&index=0&id=71fa7c56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports